import axios from 'axios'

const logsApi = axios.create({
  baseURL: process.env.REACT_APP_LOGS_API_URL,
  headers: {
    'x-api-key': process.env.REACT_APP_LOGS_API_KEY,
  },
})

export default logsApi
